// eslint-disable-next-line no-unused-vars
var Backstage = Barba.BaseView.extend({
    namespace: 'backstage',
    onEnter: function() {
       
    },
    onEnterCompleted: function() {
        
    },
    onLeave: function() {
        
    },
    onLeaveCompleted: function() {
    }
  });
